import moment from 'moment-timezone';

const WORK_WITH_DATE = {

  methods: {

    /**
         * Method for get current year
         */
    getCurrentYear () {
      return moment();
    },

    /**
         * Method for get current year
         */
    getTimeZone () {
      return moment.tz.guess();
    },

    /**
         * Method for change start point year exp: { 1 Jan 2010 }
         *
         * @param {Unix} date
         */
    getStartSelectYear (date) {
      return moment(date).utc().startOf('year');
    },

    /**
         * Method for change end point year
         *
         * @param {Unix} date
         */
    getEndSelectYear (date) {
      return moment(date).utc().endOf('year');
    },

    /**
         * Method for get year + 1
         *
         * @param {Unix} date
         */
    getLastYear (date) {
      return moment(date).subtract(12, 'months');
    },

    /**
         * Method for convert data to unix format
         *
         * @param {Any} date
         */
    convertDatePickerInUnix (date) {
      if (date._isAMomentObject) {
        return date !== '' ? moment(date).unix() : '';
      }

      if (typeof date === 'object') {
        return (date !== '' && date[0] !== null) ? date.map((item) => moment(item).unix()).join(',') : '';
      }

      return date !== '' ? moment(date).unix() : '';
    },

  },

};

export default WORK_WITH_DATE;
